import React, { Component, Fragment } from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Link } from 'react-router-dom';
import { Container,Row,Col,Button} from 'react-bootstrap'
import Product1 from '../../assets/images/product/pospresso11.png'


class Pospresso extends Component {
     render() {
          return (
               <Fragment>
              <Container fluid={true}  className="BetweenTwoSection">
                  <div className="breadbody">
                <Breadcrumb>
  <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
    <Breadcrumb.Item> <Link to="/products"> Product </Link> </Breadcrumb.Item>
  <Breadcrumb.Item> <Link to="/pospresso"> Pospresso </Link> </Breadcrumb.Item>   
</Breadcrumb>
</div>
<div className="d-flex justify-content-between align-items-center mb-2">
  <h2 className="section-title text-primary m-0"></h2>

 
   <Link to="/pospressolive">
          
         
            <Button size="sm" variant="primary">
                 Live Demo
            </Button>
            </Link>
</div>
     <h2 className="section-title text-center mb-2 text-primary"> POSPRESSO</h2>
   

<p className="text-center mb-3"> Comprehensive Point of Sale (POS) software</p>
    
    

                   <Row className="p-2">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          <Col className="p-3" md={6} lg={6} sm={12} xs={12}>
           <img  className="product-main"  src={Product1}  alt="ParkEase Dashboard"/>
          <Container  className="my-3">
              
          </Container>
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>     
          <p>Pospresso is a comprehensive Point of Sale (POS) software designed to streamline operations in hotels and restaurants. It efficiently manages orders, billing, and staff performance while giving different levels of access to users based on their roles.</p>
          <div className="">
           <h6> User Roles and Permissions</h6>
               <h6>Login to the System</h6>
              <p className="login-steps">
               Open the system in your browser,
               Enter your username/email,
               Enter your password,
               Click Login
               </p>
               <h4>Admin </h4>
                 <ul>
               <li>Full access to the system.</li>
               <li>Can create and manage tables.</li>
               <li>Can add, edit, and manage users (Waiters and Cashiers).</li>
               <li>Can add menus and categories that all users can access during sales.</li>
               <li>Can edit invoices (Waiters cannot; Cashiers can).</li>
               <li>Can view the dashboard showing:</li>
                <ul>
               <li>Tickets printed.</li>
               <li>Can create and manage tables.</li>
               <li>Orders of the day</li>
               <li>Total income and expenditure</li>
               <li>Waiters’ performance</li>
               <li>Can monitor all activities of waiters and cashiers.</li>
               <li>Detailed and summary reports</li>
               </ul>
               </ul>
          </div>
          </Col>
     </Row>

     <Row>
          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">Cashier</h6>

          <ul>
               <li>Takes orders (if needed).</li>
               <li>Can print receipts, invoices, and tickets.</li>
               <li>Can edit invoices.</li>
               <li>Can view reports.</li>
               <li>Ensures proper billing and transaction management.</li>
              
               </ul>
          </Col>

          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">Waiter</h6>
  <ul>
               <li>Takes orders from customers.</li>
               <li>Prints kitchen tickets.</li>
               <li>Can view only their own tickets and invoices.</li>
               <li>Cannot edit invoices.</li>
               <li>Focused on order management and serving customers efficiently.</li>
              
               </ul>
          </Col>
     </Row>

</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default Pospresso